import React, { useState } from "react";

import styles from "./FieldsBox.module.css";

import { StarRating } from "../StarRating/StarRating";
import { TagEditor } from "../TagEditor/TagEditor";
import { Readings } from "../Readings/Readings";
import { useMedia, useMediaUpdate } from "../../contexts/MediaContext";
import { BookProgressUpdater } from "../ProgressUpdater/BookProgressUpdater";
import { TVShowProgressUpdater } from "../ProgressUpdater/TVShowProgressUpdater";
import { StatusEditor } from "../StatusEditor/StatusEditor";


export const FieldsBox = () => {

    // ----------------------------------------------------- STATE AND HOOKS
    const mediaItem = useMedia();
    const mediaUpdater = useMediaUpdate();

    let location = window.location.href;

    const [isEditing, setEditingTags] = useState(false);

    // ----------------------------------------------------- PRE-RENDER

    const updateTagEditing = () => {
        //toggles tag edditng box
        setEditingTags(!isEditing)
    }

    // ----------------------------------------------------- RENDER

    return (
        <div className={styles.container}>
            <h3 className={styles.infoTitle}>Status</h3>
            <StatusEditor />
            {mediaItem.type !== "tvshow" && mediaItem.status === "currentlyReading" && mediaItem.numpages !== 0 ?
                <div>
                    <h3 className={styles.infoTitle}>Progress</h3>
                    <BookProgressUpdater mediaItem={mediaItem} bookUpdater={mediaUpdater} />
                </div>
                :
                null
            }
            {location.includes("/tvshow") && mediaItem.status === "currentlyReading" ?
                <div>
                    <h3 className={styles.infoTitle}>Progress</h3>
                    {mediaItem.progress >= mediaItem.numpages ?
                        null
                        :
                        <h4 className={styles.infoSubTitle}>Next Episode: {mediaItem.submedia[mediaItem.progress]?.title}</h4>
                    }
                    <TVShowProgressUpdater tvshowItem={mediaItem} tvshowUpdater={mediaUpdater} />
                </div>
                :
                null
            }

            <h3 className={styles.infoTitle}>Rating</h3>
            <StarRating isEditing = {isEditing}/>

            <Readings />

            <div className={styles.titleAndButtonTAG}>
                <h3 className={styles.infoTitle}>Tags</h3>
                {
                    mediaItem.tags !== null && mediaItem.tags?.length !== 0 ?
                        <button
                            className={styles.editButton}
                            onClick={updateTagEditing}>
                            <img src="/assets/images/editIcon.svg"
                                className={styles.editButtonImage}
                                alt="Edit Icon" />
                        </button>
                        :
                        null
                }
            </div>
            <TagEditor isEditingTag={isEditing}/>
        </div>
    );
}
